import React, { useState } from 'react';
import { Form, Input, Button, Typography, message } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { useNavigate } from 'react-router-dom';
import UserPool from '../../utils/userPool';
import useTranslation from '../../hooks/useTranslation';

const { Title } = Typography;

const ForgotPasswordPage = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onFinish = (values) => {
        const { email } = values;
        setLoading(true);

        const user = new CognitoUser({
            Username: email,
            Pool: UserPool,
        });

        user.forgotPassword({
            onSuccess: () => {
                message.success(t('auth.codeSent'));
                navigate('/reset-password', { state: { email } });
            },
            onFailure: (err) => {
                message.error(t('auth.codeSendFailed', { message: err.message }));
            },
        });

        setLoading(false);
    };

    return (
        <div style={{ maxWidth: 400, margin: 'auto', padding: '2rem' }}>
            <Title level={3} style={{ textAlign: 'center' }}>{t('auth.forgotPasswordTitle')}</Title>
            <Form onFinish={onFinish} layout="vertical">
                <Form.Item
                    name="email"
                    rules={[{ required: true, type: 'email', message: t('auth.invalidEmail') }]}
                >
                    <Input
                        prefix={<MailOutlined />}
                        placeholder={t('auth.emailAddress')}
                    />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" block loading={loading}>
                        {t('auth.sendCode')}
                    </Button>
                </Form.Item>
                <Button type="text" block onClick={() => navigate('/login')}>
                    {t('auth.backToLogin')}
                </Button>
            </Form>
        </div>
    );
};

export default ForgotPasswordPage;
